import { combineReducers } from "redux";
import { initialScrapeTasksReducer } from "modules/Scheduler/services/InitialScrapeTasks/reducer";
import { initialScrapeTasksStatisticReducer } from "modules/Scheduler/services/InitialScrapeTasksStatistic/reducer";

export const schedulerReducer = combineReducers({ 
    entries: initialScrapeTasksReducer,
    statistic: initialScrapeTasksStatisticReducer 
});